// import mixpanel from 'mixpanel-browser';

// import { isProduction } from '@proprioo/hokkaido';

import { ArbitraryObject } from './interfaces';

export enum EVENT_NAME {
  ACT_AUTHENTIC_SIGNED = 'actAuthenticSigned',
  ACTIVITY_CREATED = 'activityCreated',
  ACTIVITY_VALIDATED = 'activityValidated',
  BUYER_LEAD_CREATED = 'buyingProjectCreated',
  COMPROMISE_SIGNED = 'compromiseSigned',
  CONTRACT_SIGNED = 'contractSigned',
  LISTING_SHARED = 'listingShared',
  LISTING_PUBLISHED = 'listingPublished',
  MANDATE_GENERATED = 'mandateGenerated',
  MEETING_VALIDATED = 'meetingValidated',
  OFFER_CREATED = 'offerCreated',
  OUTBOUND_PROSP_CREATE_ALERT = 'outboundProspCreateAlert',
  OUTBOUND_PROSP_DETAILS = 'outboundProspDetails',
  OUTBOUND_PROSP_HISTORY = 'outboundProspHistory',
  OUTBOUND_PROSP_LEAD_ASSIGNED = 'outboundProspLeadAssigned',
  OUTBOUND_PROSP_SEARCH = 'outboundProspSearch',
  OUTBOUND_PROSP_SEE_EXPIRED_PROPERTIES = 'outboundProspSeeExpiredProperties',
  PAGE_VIEWED = 'pageViewed',
  SEARCH = 'search',
  SELLER_LEAD_ARCHIVED = 'projectArchived',
  SELLER_LEAD_CREATED = 'sellingProjectCreated',
  SELLER_LEAD_MANAGEMENT = 'sellerLeadManagement',
  SELLER_PROJECT_CONVERTED = 'sellerProjectConverted',
  SIGNED_IN = 'signedIn'
}

/**
 * This function is intentionally a no-op (no operation).
 *
 * @param {string} email - The email address of the user to be identified in Mixpanel.
 */
export const identifyUserOnMixpanel = (email: string) => {
  void email;
  // No operation

  /*
  if (isProduction()) {
    mixpanel.identify(email);
  }
  */
};

/**
 * This function is intentionally a no-op (no operation).
 *
 * @param {ArbitraryObject} data - An object containing user properties to be sent to Mixpanel.
 */
export const addUserPropertiesOnMixpanel = (data: ArbitraryObject) => {
  void data;
  // No operation

  /*
  if (isProduction()) {
    mixpanel.people.set_once(data);
  }
  */
};

/**
 * This function is intentionally a no-op (no operation).
 *
 * @param {EVENT_NAME} eventName - The name of the event to track on Mixpanel.
 */
export const trackTimeEventOnMixPanel = (eventName: EVENT_NAME) => {
  void eventName;
  // No operation

  /*
  if (isProduction()) {
    mixpanel.time_event(eventName);
  }
  */
};

/**
 * This function is intentionally a no-op (no operation).
 *
 * @param eventName - The name of the event that would have been tracked.
 * @param data - (Optional) Additional data that would have been sent with the event.
 */
export const trackEventOnMixpanel = (
  eventName: EVENT_NAME,
  data?: ArbitraryObject
) => {
  void eventName;
  void data;
  // No operation

  /*
  if (isProduction()) {
    mixpanel.track(eventName, data);
  }
  */
};
